module.exports = __webpack_public_path__ + "img/SPZLab.7f5fdb23.jpg";